import { Card, CardContent, SxProps, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import { DetailsAccordion } from '../assignment-details-accordion/AssignmentDetailsAccordion';
import { useDesktop } from '../useDesktop';

export interface SimulationCodeProps {
  code: string;
  sx?: SxProps;
}

interface SimulationCodeHeaderProps {
  children: ReactNode;
  header: ReactNode;
}

const SimulationCodeHeader = ({ children, header }: SimulationCodeHeaderProps) => (
  <CardContent sx={{ textAlign: 'center' }}>
    <Typography component="h3" variant="h6" mb={1}>
      {header}
    </Typography>
    {children}
  </CardContent>
);

const SimulationCode = ({ code, sx = {} }: SimulationCodeProps) => {
  const Wrapper = useDesktop() ? SimulationCodeHeader : DetailsAccordion;

  return (
    <Card sx={sx}>
      <Wrapper header="Simulation code">
        <Typography
          component="span"
          variant="h3"
          sx={{
            color: 'primary.main',
            letterSpacing: '1ch',
            mr: '-1ch',
          }}
        >
          {code}
        </Typography>
      </Wrapper>
    </Card>
  );
};

export default SimulationCode;
